import { GetterTree } from 'vuex'
import RootState from './RootState'

const getters: GetterTree <RootState, RootState> = {}

export default getters;